/**
 * Constants for the Stock Rebalancer module
 * Shared across all rebalancer components
 */

// Status badge colors
export const STATUS_STYLES = {
  LOW: "bg-red-100 text-red-700 border-red-200",
  OPTIMAL: "bg-emerald-100 text-emerald-700 border-emerald-200",
  OVERSTOCK: "bg-amber-100 text-amber-700 border-amber-200",
  IMBALANCED: "bg-purple-100 text-purple-700 border-purple-200",
};

export const STATUS_LABELS = {
  LOW: "Low Stock",
  OPTIMAL: "Optimal",
  OVERSTOCK: "Overstock",
  IMBALANCED: "Imbalanced",
};

// Shop type badge styles
export const SHOP_TYPE_STYLES = {
  normal: "bg-slate-100 text-slate-700 border-slate-200",
  warehouse: "bg-blue-100 text-blue-700 border-blue-200",
};

// Threshold source styles for unified dialog
export const THRESHOLD_SOURCE_STYLES = {
  shop_override: "bg-purple-100 text-purple-700 border-purple-200",
  custom: "bg-indigo-50 text-indigo-600 border-indigo-200",
  default: "bg-gray-50 text-gray-500 border-gray-200",
};

export const THRESHOLD_SOURCE_LABELS = {
  shop_override: "SHOP",
  custom: "CUSTOM",
  default: "DEFAULT",
};
